import { Injectable } from '@angular/core';

export interface BrowserInfo {
  name: string;
  version: number;
  isChrome: boolean;
  isSupported: boolean;
  userAgent: string;
}

@Injectable({
  providedIn: 'root'
})
export class BrowserCompatibilityService {
  private readonly MIN_CHROME_VERSION = 120;

  isRecommendedBrowser(): boolean {
    return this.isGenuineChrome() && this.detectChromeVersion() >= this.MIN_CHROME_VERSION;
  }

  private isGenuineChrome(): boolean {
    const ua = navigator.userAgent;
    const vendor = navigator.vendor;
    const win = window as any;

    if (!/Chrome\//.test(ua)) return false;
    if (vendor !== 'Google Inc.') return false;
    if (typeof win.chrome === 'undefined') return false;

    if (/Edg\/|OPR\/|Vivaldi\/|SamsungBrowser|Firefox\//.test(ua)) {
      return false;
    }

    if (win.navigator.brave) return false;

    const hasChromeAPI =
      typeof win.chrome.loadTimes === 'function' ||
      typeof win.chrome.csi === 'function' ||
      typeof win.chrome.app !== 'undefined';

    if (!hasChromeAPI) {
      return false;
    }

    return true;
  }
  private detectBrowserName(): string {
    const ua = navigator.userAgent;
    const win = window as any;

    if (win.navigator.brave) return 'Brave';
    if (/Edg\//.test(ua)) return 'Edge';
    if (/OPR\//.test(ua)) return 'Opera';
    if (/Vivaldi\//.test(ua)) return 'Vivaldi';
    if (/Firefox\//.test(ua)) return 'Firefox';
    if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'Safari';

    if (this.isGenuineChrome()) return 'Chrome';

    if (/Chrome\//.test(ua)) return 'Chromium based browser';

    return 'Unknow browser';
  }
  private detectChromeVersion(): number {
    const ua = navigator.userAgent;
    const match = ua.match(/Chrome\/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }
}
